"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _reactDayPicker = require("react-day-picker");

var _reactTransitionGroup = require("react-transition-group");

var _classNames = _interopRequireDefault(require("../date-picker/classNames"));

var _datePicker = _interopRequireDefault(require("../date-picker"));

var _presets = _interopRequireDefault(require("../date-picker/presets"));

var _data = _interopRequireDefault(require("../date-picker/presets/data"));

var _input = _interopRequireDefault(require("../input"));

var _messages = _interopRequireDefault(require("./messages"));

var _messages2 = _interopRequireDefault(require("../date-picker/messages"));

var _rangeTimePicker = _interopRequireDefault(require("./range-time-picker"));

var _timezonePicker = _interopRequireDefault(require("./timezone-picker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DatePickerInputRange = /*#__PURE__*/function (_PureComponent) {
  _inherits(DatePickerInputRange, _PureComponent);

  var _super = _createSuper(DatePickerInputRange);

  function DatePickerInputRange(props) {
    var _this;

    _classCallCheck(this, DatePickerInputRange);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleVisible", function () {
      return _this.setState({
        visible: !_this.state.visible
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setHoveredDay", function (day) {
      return _this.setState({
        hoveredDay: day
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      return _this.setState({
        visible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTimezoneChange", function (value) {
      var input = _this.props.input;

      _this.setState({
        timezone: value
      });

      _this.handleChange({
        from: input.value.from,
        to: input.value.to,
        label: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (_ref) {
      var from = _ref.from,
          to = _ref.to,
          label = _ref.label;
      var visibleTimePicker = _this.props.visibleTimePicker;

      if (from && to && !visibleTimePicker) {
        _this.toggleVisible();
      }

      return _this.props.input.onChange({
        from: from,
        to: to
      }, label || _this.state.timezone);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDayClick", function (date) {
      var input = _this.props.input;
      var status = {
        isEmpty: !input.value.from && !input.value.to,
        isCompleted: input.value.from && input.value.to,
        isStarted: input.value.from && !input.value.to
      };

      _this.setHoveredDay(null);

      if (status.isEmpty || status.isCompleted) {
        return _this.handleChange({
          from: date,
          to: null
        });
      }

      if (status.isStarted && (_reactDayPicker.DateUtils.isSameDay(date, input.value.from) || _reactDayPicker.DateUtils.isDayAfter(date, input.value.from))) {
        return _this.handleChange({
          from: input.value.from,
          to: date
        });
      }

      return _this.handleChange({
        from: date,
        to: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTimeClick", function (type, date) {
      var input = _this.props.input;

      if (type === 'from') {
        return _this.handleChange({
          from: date,
          to: input.value.to
        });
      }

      if (type === 'to') {
        return _this.handleChange({
          from: input.value.from,
          to: date
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDayMouseEnter", function (date) {
      var input = _this.props.input;

      if (input.value.from && !input.value.to && _reactDayPicker.DateUtils.isDayAfter(date, input.value.from)) {
        return _this.setHoveredDay(date);
      }

      return _this.setHoveredDay(null);
    });

    _defineProperty(_assertThisInitialized(_this), "humanizeOutputValue", function (value) {
      var _this$props = _this.props,
          visibleTimePicker = _this$props.visibleTimePicker,
          visibleTimezonePicker = _this$props.visibleTimezonePicker,
          timezones = _this$props.timezones;
      var filledLength = Object.values(value).filter(function (a) {
        return a;
      }).length;

      if (!filledLength) {
        return '';
      }

      return [value.from, value.to].map(function (a) {
        if (a instanceof Date) {
          return visibleTimePicker ? "".concat(_this.props.intl.formatDate(a), " ").concat(_this.props.intl.formatTime(a)) : _this.props.intl.formatDate(a);
        }

        return _this.props.intl.formatMessage(_messages["default"].selectData);
      }).join(' — ').concat(visibleTimezonePicker && timezones ? ", UTC".concat(_this.state.timezone) : '');
    });

    _defineProperty(_assertThisInitialized(_this), "getActions", function () {
      var _this$props2 = _this.props,
          intl = _this$props2.intl,
          visibleClearButton = _this$props2.visibleClearButton,
          visibleOkButton = _this$props2.visibleOkButton;
      var emptyAction = {
        label: '',
        onClick: function onClick() {
          return void 0;
        }
      };
      var actionClearType = visibleClearButton ? {
        label: intl.formatMessage(_messages2["default"].clear),
        onClick: function onClick() {
          _this.handleChange({
            from: null,
            to: null
          });

          _this.toggleVisible();
        }
      } : emptyAction;
      var actionOkType = visibleOkButton ? {
        label: intl.formatMessage(_messages2["default"].ok),
        onClick: function onClick() {
          _this.toggleVisible();
        }
      } : emptyAction;
      return visibleClearButton || visibleOkButton ? [actionClearType, actionOkType] : [];
    });

    var defaultDateParts = new Date().toString().split(/[()]/);
    var defaultTimezone = defaultDateParts[1] ? defaultDateParts[1].replace('GMT', '') : '';
    _this.state = {
      visible: false,
      hoveredDay: null,
      timezone: _this.props.timezone || defaultTimezone
    };
    return _this;
  }

  _createClass(DatePickerInputRange, [{
    key: "render",
    value: function render() {
      var _ref2;

      var _this$props3 = this.props,
          intl = _this$props3.intl,
          input = _this$props3.input,
          meta = _this$props3.meta,
          size = _this$props3.size,
          placeholder = _this$props3.placeholder,
          disabled = _this$props3.disabled,
          customInput = _this$props3.customInput,
          presetsData = _this$props3.presetsData,
          visiblePresets = _this$props3.visiblePresets,
          visibleTimePicker = _this$props3.visibleTimePicker,
          timePickerProps = _this$props3.timePickerProps,
          ampmTimeFormat = _this$props3.ampmTimeFormat,
          visibleTimezonePicker = _this$props3.visibleTimezonePicker,
          timezones = _this$props3.timezones,
          datePickerRestProps = _objectWithoutProperties(_this$props3, ["intl", "input", "meta", "size", "placeholder", "disabled", "customInput", "presetsData", "visiblePresets", "visibleTimePicker", "timePickerProps", "ampmTimeFormat", "visibleTimezonePicker", "timezones"]);

      var timezone = this.state.timezone;
      var requiredInputProps = {
        input: {
          name: input.name,
          value: this.humanizeOutputValue(input.value),
          onChange: function onChange() {
            return void 0;
          }
        },
        meta: meta,
        size: size,
        placeholder: placeholder || intl.formatMessage(_messages["default"].placeholder),
        disabled: disabled,
        focused: this.state.visible,
        onClick: this.toggleVisible
      };
      return /*#__PURE__*/_jsx("div", {
        style: {
          position: 'relative',
          display: 'inline-block'
        }
      }, void 0, customInput ? /*#__PURE__*/(0, _react.cloneElement)(customInput(_objectSpread(_objectSpread({}, requiredInputProps), {}, {
        raw: input.value,
        intl: intl
      }))) : /*#__PURE__*/_react["default"].createElement(_input["default"], _extends({}, requiredInputProps, {
        icon: "calendar",
        offset: "left-separated",
        inline: true,
        readOnly: true
      })), /*#__PURE__*/_jsx(_reactTransitionGroup.TransitionGroup, {}, void 0, this.state.visible && /*#__PURE__*/_jsx(_reactTransitionGroup.CSSTransition, {
        classNames: "slide-transition",
        timeout: 100
      }, void 0, /*#__PURE__*/_react["default"].createElement(_datePicker["default"], _extends({}, datePickerRestProps, {
        initialMonth: input.value.from ? new Date(input.value.from) : new Date(),
        selectedDays: [input.value.from, {
          from: input.value.from,
          to: input.value.to || this.state.hoveredDay
        }],
        modifiers: (_ref2 = {}, _defineProperty(_ref2, _classNames["default"].start, input.value.from), _defineProperty(_ref2, _classNames["default"].startCompleted, input.value.to || this.state.hoveredDay ? input.value.from : null), _defineProperty(_ref2, _classNames["default"].end, input.value.to), _defineProperty(_ref2, _classNames["default"].endHovered, this.state.hoveredDay), _ref2),
        onDayClick: this.handleDayClick,
        onDayMouseEnter: this.handleDayMouseEnter,
        timePicker: visibleTimePicker && /*#__PURE__*/_jsx(_rangeTimePicker["default"], {
          input: input,
          timePickerProps: timePickerProps,
          ampmTimeFormat: ampmTimeFormat,
          handleTimeClick: this.handleTimeClick
        }),
        timezonePicker: visibleTimezonePicker && timezones && /*#__PURE__*/_jsx(_timezonePicker["default"], {
          timezone: timezone,
          timezones: timezones,
          handleTimezoneChange: this.handleTimezoneChange
        }),
        footer: visiblePresets && /*#__PURE__*/_jsx(_presets["default"], {
          value: input.value,
          onChange: this.handleChange,
          data: presetsData || (0, _data["default"])(intl)
        }),
        actions: this.getActions()
      })))));
    }
  }]);

  return DatePickerInputRange;
}(_react.PureComponent);

_defineProperty(DatePickerInputRange, "defaultProps", {
  size: 'sm',
  numberOfMonths: 2,
  visiblePresets: false,
  visibleClearButton: false
});

var _default = (0, _reactIntl.injectIntl)((0, _reactOnclickoutside["default"])(DatePickerInputRange));

exports["default"] = _default;